import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup
} from "@mui/material";
import LogItem from "../AdminPanel/LogItem";
import {useCallback, useEffect, useState} from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ReactJsonViewCompare from "react-json-view-compare";
import ReactJson from "react-json-view";
import {useGetPreHistoryQuery} from "../../core/reducers/campaign";
import {useGetTemplatePreHistoryQuery} from "../../core/reducers/templates";
import Loading from "../Loading";
import dayjs from "dayjs";
import Audience from "../Publisher/Audience";
import {formatDate} from "../Utils/CommonUtils";
import {computeBundleUpdateInfo} from "../../core/transfer/bundleUpdate";


export default function PublishDiffItem({resourceType = 'campaign', env1, env2, campaignId, oldItem, setSkipBundleUpdateList, skipBundleUpdateList, onBundleUpdateInfo}) {
    // const data = {"oldCampaign":{"id":"20241217_TT026_BackToClocksvilleFTUE_TRGOR","groupId":"20241217_TT026_BackToClocksvilleFTUE_TRGOR","priority":0,"status":"ACTIVE","type":"temporary_town","bundleId":"TT026_BackToClocksvilleFTUE_TRGOR","fixedBundle":null,"tags":null,"fickle":false,"repeatable":false,"matchmakingType":null,"distribution":{"type":"fixed","from":1734400800,"till":1765936800,"duration":0.0},"audiences":[{"include":[{"parameter":"ab_test_cohort","values":["20250110_AB_FTUE_Monetisation:B"]}],"includeAll":[],"exclude":[],"excludeAll":[],"range":[{"parameter":"saga_wins","from":50,"fromIncluded":true,"to":null,"toIncluded":false}],"version":[{"parameter":"version","from":{"version":"90.0.0"},"fromIncluded":true,"to":null,"toIncluded":false}],"profileOffset":[],"offerInProfile":[],"offerNotInProfile":[],"offerInactiveRule":[],"offerTypeInactiveRule":[],"offerTagInactiveRule":[]}]},"newCampaign":{"id":"20241217_TT026_BackToClocksvilleFTUE_TRGOR","groupId":"20241217_TT026_BackToClocksvilleFTUE_TRGOR","priority":0,"status":"ACTIVE","type":"temporary_town","bundleId":"TT026_BackToClocksvilleFTUE_TRGOR","fixedBundle":null,"tags":["tag1"],"fickle":false,"repeatable":false,"matchmakingType":null,"distribution":{"type":"fixed","from":1734400800,"till":1765936800,"duration":0.0},"audiences":[{"include":[{"parameter":"ab_test_cohort","values":["20250110_AB_FTUE_Monetisation:B"]}],"includeAll":[],"exclude":[],"excludeAll":[],"range":[{"parameter":"saga_wins","from":50,"fromIncluded":true,"to":null,"toIncluded":false}],"version":[{"parameter":"version","from":{"version":"90.0.0"},"fromIncluded":true,"to":null,"toIncluded":false}],"profileOffset":[],"offerInProfile":[],"offerNotInProfile":[],"offerInactiveRule":[],"offerTypeInactiveRule":[],"offerTagInactiveRule":[]}]},"oldBundle":{"id":"TT026_BackToClocksvilleFTUE_TRGOR","campaignType":"temporary_town","generations":{"1":{"clientVersion":{"version":"85.1.0"},"bundleVersion":8,"generation":1,"data":{"contentBranch":"TT/TT026_BackToClocksvilleFTUE_TRGOR/G1","repositoryBranch":"v90/build/90.0.0","buildLink":null,"date":1735638371,"platformToCatalogFile":{"WebGL_downscale":"webgl-downscale-TT026_BackToClocksvilleFTUE_TRGOR_1735638245","StandaloneOSX":"osx-TT026_BackToClocksvilleFTUE_TRGOR_1735637856","iOS":"ios-TT026_BackToClocksvilleFTUE_TRGOR_1735637361","StandaloneWindows64":"desktop-TT026_BackToClocksvilleFTUE_TRGOR_1735637814","WSAPlayer":"wsa-TT026_BackToClocksvilleFTUE_TRGOR_1735637705","Android_downscale":"android-downscale-TT026_BackToClocksvilleFTUE_TRGOR_1735638096","Android":"android-TT026_BackToClocksvilleFTUE_TRGOR_1735637555"}}}}},"newBundle":{"id":"TT026_BackToClocksvilleFTUE_TRGOR","campaignType":"temporary_town","generations":{"1":{"clientVersion":{"version":"85.1.0"},"bundleVersion":8,"generation":1,"data":{"contentBranch":"TT/TT026_BackToClocksvilleFTUE_TRGOR/G1","repositoryBranch":"v90/build/90.0.0","buildLink":null,"date":1735638371,"platformToCatalogFile":{"WebGL_downscale":"webgl-downscale-TT026_BackToClocksvilleFTUE_TRGOR_1735638245","StandaloneOSX":"osx-TT026_BackToClocksvilleFTUE_TRGOR_1735637856","iOS":"ios-TT026_BackToClocksvilleFTUE_TRGOR_1735637361","StandaloneWindows64":"desktop-TT026_BackToClocksvilleFTUE_TRGOR_1735637814","WSAPlayer":"wsa-TT026_BackToClocksvilleFTUE_TRGOR_1735637705","Android_downscale":"android-downscale-TT026_BackToClocksvilleFTUE_TRGOR_1735638096","Android":"android-TT026_BackToClocksvilleFTUE_TRGOR_1735637555"}}}}},"generationsToUpdate":[]}
    // const isError = false
    // const isLoading = false
    // const error = false
    const queryArgs = {
        environment: env2, event_id: campaignId, source: env1
    };
    const campaignDifference = useGetPreHistoryQuery(queryArgs, {
        skip: resourceType === 'template'
    });
    const templateDifference = useGetTemplatePreHistoryQuery(queryArgs, {
        skip: resourceType !== 'template'
    });
    const {data, isLoading, isError, error} = resourceType === 'template'
        ? templateDifference
        : campaignDifference;



    const [openDiff, setOpenDiff] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const onSelectedRow = useCallback((row) => {
        setSelectedRow(row);
    }, []);

    const onOpenDiff = useCallback((value) => {
        setOpenDiff(value);
    }, []);

    const onOpenInfo = useCallback((value) => {
        setOpenInfo(value);
    }, []);


    const handleCloseDiff = () => {
        setOpenDiff(false);
        setOpenInfo(false);
        setSelectedRow(null);
    };


    const getCampaignChanges = (data) => {

        return {
            id: data.newCampaign['id'],
            newData: data.newCampaign,
            oldData: data.oldCampaign == null ? oldItem.item : data.oldCampaign,
            eventId: data.newCampaign["id"],
            eventType: "CAMPAIGN",
            adminAction: data.oldCampaign == null ? "EVENT_CREATION_BY_TRANSFER": "EVENT_UPDATE",
            creationDateSeconds: Date.now()/1000,
            userEmail:"",
            userName:"",
            info:{
                id: data.newBundle.id,
                currentBundle: {
                    generations: (data.generationsToUpdate !== null && data.generationsToUpdate.length>0) ? data.generationsToUpdate : data.newBundle.generations
                }
            }
        }
    }

    const getBundleChanges = (data) => {
        return {
            id: data.newBundle.id,
            newData: data.newBundle,
            oldData: data.oldBundle, //data.oldCampaign,
            eventId: data.newCampaign["id"],
            eventType: "BUNDLE",
            adminAction: data.oldBundle==null||(data.oldBundle.hasOwnProperty('generations')&&Object.keys(data.oldBundle?.generations).length==0)?"EVENT_CREATION_BY_TRANSFER":"BUNDLE_UPDATE",
            creationDateSeconds: Date.now()/1000,
            userEmail:"",
            userName:"",
            info:{
                // id: data.newBundle.id,
                // currentBundle: {
                //     id: data.newBundle.id,
                //     generations: data.generationsToUpdate
                // }
            }
        }
    }

    const getTableRows = (item) => {
        const { newData, oldData, adminAction } = item;
        const allRows = [
            { label: 'Type', key: 'type', value: newData.type },
            { label: 'Bundle ID', key: 'bundleId', value: newData.bundleId },
            { label: 'Group ID', key: 'groupId', value: newData.groupId },
            { label: 'Priority', key: 'priority', value: newData.priority },
            { label: 'Tags', key: 'tags', value: newData.tags!=undefined?newData.tags.join(', '):'' },
            //{ label: 'Tag', key: 'tag', value: newData.tag != undefined && newData.tag != null ? newData.tag : ''},
            {
                label: 'Status',
                key: 'status',
                value: (
                    <>
                        <span className={`status status-${newData?.status?.toLocaleLowerCase()}`}>{newData.status}</span>
                    </>
                ),
            },
            {
                label: 'Distribution',
                key: 'distribution',
                value: (
                    <div>
                        <div>
                            <span>Type: {newData?.distribution?.type}</span>&nbsp;&nbsp;&nbsp;
                            <span>Duration: {newData?.distribution?.duration / 3600}h</span>&nbsp;&nbsp;&nbsp;
                        </div>
                        <div>
                            {formatDate(newData?.distribution?.from * 1000, 'YYYY-MM-DD HH:mm:ss')}
                            &nbsp;-&nbsp;
                            {formatDate(newData?.distribution?.till * 1000, 'YYYY-MM-DD HH:mm:ss')}

                        </div>
                    </div>
                ),
            },
            {
                label: 'Audience',
                key: 'audiences',
                value: newData?.audiences?.map((audience, index) => (
                    <Audience key={index} audience={audience}>
                        Audience {(index + 1)}<br />
                    </Audience>
                )),
            },
            {
                label: 'Advanced flags',
                key: 'advancedFlags',
                value: (
                    <FormGroup row>
                        <FormControlLabel control={<Checkbox checked={newData?.fickle} />} label="Check Audience Every Time (fickle)" />
                        <FormControlLabel control={<Checkbox checked={newData?.repeatable} />} label="Allow repeat after finish (repeatable)" />
                    </FormGroup>
                ),
                changed: newData?.fickle !== oldData?.fickle || newData?.repeatable !== oldData?.repeatable,
            },
        ];

        if (adminAction === 'EVENT_UPDATE' || adminAction === 'EVENT_UPDATE_BY_TRANSFER' || adminAction === 'STATUS_CHANGING') {
            const changedKeys = getChangedRows(newData, oldData);
            return allRows.filter(row => changedKeys.includes(row.key) || row.changed);
        }

        return allRows;
    };


    const getChangedRows = (newData, oldData) => {
        const changes = [];
        for (const key in newData) {
            if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
                changes.push(key);
            }
        }
        return changes;
    };

    const item = data !== undefined ? getCampaignChanges(data) : {}
    const item2 = data !== undefined ? getBundleChanges(data) : {}

    const skipUpdate = skipBundleUpdateList.includes(campaignId);
    const bundleUpdate = computeBundleUpdateInfo(data);
    const hasUpdates = bundleUpdate.hasBundleUpdate;

    const checkAudienceUpdates = () => {
        let t = {...item.oldData}
        let t2 = {...item.newData}
        t['fixedBundle'] = null
        t2['fixedBundle'] = null

        return (JSON.stringify(t)!=JSON.stringify(t2))
    }
    const hasAudienceUpdates = checkAudienceUpdates()
    const hasBundleUpdates = (JSON.stringify(item2.oldData)!=JSON.stringify(item2.newData))

    // Сообщаем родителю о потенциальном изменении версии бандла.
    // Важно: данные prehistory имеют keepUnusedDataFor: 0 и пропадают при размонтировании,
    // поэтому поднимаем их в родителя заранее. Признак "skip" учитывается родителем по skipBundleUpdateList.
    useEffect(() => {
        if (typeof onBundleUpdateInfo !== 'function') return;
        onBundleUpdateInfo(campaignId, bundleUpdate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, campaignId]);

    return <>
        <h4>{campaignId}  {hasUpdates&&<FormControlLabel control={<Checkbox onChange={() => {
            setSkipBundleUpdateList(prev => {
                if (skipUpdate) {
                    return prev.filter(item => item !== campaignId)
                } else {
                    return [...prev, campaignId]
                }
            })
        } } checked={skipUpdate} />} label="Skip bundle update" />}</h4>

        <Loading isLoading={isLoading} isError={isError} error={error}>
            {data !== undefined&&hasAudienceUpdates&&<LogItem key={item.id} env={env1} item={item} setSelectedRow={onSelectedRow} setOpenDiff={onOpenDiff} setOpenInfo={onOpenInfo} />}
            {data !== undefined&&item.adminAction!=='EVENT_CREATION_BY_TRANSFER'&&!skipUpdate&&data?.generationsToUpdate?.length>0&&<LogItem key={item.id} env={env1} item={item2} setSelectedRow={onSelectedRow} setOpenDiff={onOpenDiff} setOpenInfo={onOpenInfo} />}

            {item.oldData?.bundleId!=item.newData?.bundleId&&<div className={"history-item "}>BundleID Changed: {item.oldData.bundleId} -> {item.newData.bundleId}</div>}

            {!hasAudienceUpdates&&!data?.generationsToUpdate?.length>0&&<div className={"history-item "}>No Audience and Bundle Changes</div>}
        </Loading>

        {openDiff&&<Dialog open={openDiff} onClose={handleCloseDiff} maxWidth="md" fullWidth>
            <DialogTitle>JSON Diff</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleCloseDiff}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon/>
            </IconButton>
            <DialogContent>
                {!openInfo&&<ReactJsonViewCompare newData={selectedRow.newData} oldData={selectedRow.oldData} />}
                {openInfo&&<ReactJson
                    theme={'bright:inverted'}
                    src={selectedRow.info}
                    iconStyle={'square'}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    enableClipboard={false}
                />}
            </DialogContent>
            <DialogActions>


                <Button variant="outlined"
                        onClick={handleCloseDiff}>
                    Close
                </Button>

            </DialogActions>
        </Dialog>}
    </>
}
